import { render } from "./Penalties.vue?vue&type=template&id=4e40e94f"
import script from "./Penalties.vue?vue&type=script&lang=js"
export * from "./Penalties.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__